import getWallet from "./wallet";
import abi from "../abi/xGold.json";
import ownerAbi from "../abi/owner.json";
import globalAbi from "../abi/global.json";
import bankAbi from "../abi/bank.json";
import busoAbi from "../abi/buso.json";
import autolp from "../abi/autolp.json";
import tokenAbi from "../abi/token.json";
import { ethers } from "ethers";

// Mainnet
const proxyContract = "0x22d324bb60228208457711B0d66b89F174B6BDA4";
const ownerContract = "0x36e07c8421fE1fe5cC3e7619327b2c3D71a8C9Bc";
// const proxyContract = "0xcb64777a4a3E9DBd7701997774990Fbe3E600aaB";
// const ownerContract = "0x0fd0E6413B50f518A28dcA7562C16f15098E1e19";

const globalReward = "0xd61597041C0E053ed237174Da4a2688a6c11F62e";
const ipToken = "0x88CE5800627f8706edf085Bee4fB0bDAF45B8888";

// Amoy
// const proxyContract = "0xc372688f39AfAbA5F0c9AE6FD382def9C18351DC";
// const ownerContract = "0x4cCD83CB46ad43C7F6A7B6a32DeeAdF92A2f0Cc1";
// const globalReward = "0x0b7A7c1C4c21b81E9417A975f61E04b9305f9982";
// const ipToken = "0x2f2EbD42672A36F8eCfbAef43dE5ACfF62A658c0";

// local
// const proxyContract = "0xc372688f39AfAbA5F0c9AE6FD382def9C18351DC";
// const ownerContract = "0x4cCD83CB46ad43C7F6A7B6a32DeeAdF92A2f0Cc1";
// const globalReward = "0x6D544390Eb535d61e196c87d6B9c80dCD8628Acd";
// const ipToken = "0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512";

const contractCreationBlockNumber = 36878957;

const getContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(proxyContract, abi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    
    return contract;
}

export const getIpToken = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(ipToken, tokenAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  
  return contract;
}

export const getGlobalRewardContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(globalReward, globalAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  
  return contract;
}

export const getContractCreationBlock = async () => {
    return contractCreationBlockNumber;
}

export const getTotalContractTransactions = async () => {
    try {
      const wallet = await getWallet();
      const transactionCount = await wallet.provider.getTransactionCount(proxyContract);
      console.log("transactionCount: ", transactionCount);
      return transactionCount;
    } catch (error) {
      throw new Error('Failed to retrieve total contract transactions: ' + error.message);
    }
  };



export const getOwnerContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(ownerContract, ownerAbi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

const token = "0xD69071579ae36c45D63EC2D5d0E82C0a569c2cC3";

export const getTokenContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(token, tokenAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  return contract;
}


export default getContract;